import { MAX_SWATCHES_NUMBER } from '@const/index';
import styles from '@components/ProductCardNew/ProductCardDescription/SwatchesArea/SwatchesArea.styles';
import { ISwatch } from '@typescript/index';
type PropsType = {
  swatches: ISwatch[];
  totalColorsCount?: number;
};
const SwatchesArea = ({
  swatches,
  totalColorsCount
}: PropsType) => swatches.length ? <div sx={styles.productCardInfoSwatches}>
      {swatches.map((swatch, index) => {
    if (index < MAX_SWATCHES_NUMBER) return <span key={`swatch-${swatch.image}-${Math.random()}`} sx={styles.productCardInfoSwatch(swatch.image, swatch.color)} />;
    return null;
  })}
      {totalColorsCount && totalColorsCount > MAX_SWATCHES_NUMBER ? `+${totalColorsCount - MAX_SWATCHES_NUMBER}` : swatches.length > MAX_SWATCHES_NUMBER ? `+${swatches.length - MAX_SWATCHES_NUMBER}` : ''}
    </div> : <></>;
export default SwatchesArea;